module.exports = __webpack_public_path__ + "media/images/grade-badge-b-8be6ad6eab9cd2641e24fa3a4a6c3891.svg";